export const projects = [
  {
    "project_name": "Paço do Lumiar",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-pacodolumiar"
  },
  {
    "project_name": "Nazaré Paulista",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-nazarepaulista"
  },
  {
    "project_name": "Cesario Lange - Pronto Socorro",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-cesariolange-ps"
  },
  {
    "project_name": "Cesario Lange - Unidades de Saúde",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-cesariolange-unidadesdesaude"
  },
  {
    "project_name": "Rede Mario Gatti - SAD Sudoeste",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "mariogatti-sadsudoeste"
  },
  {
    "project_name": "Guarei - ESF",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-guareiesf"
  },
  {
    "project_name": "Guarei - Unidades Prisionais",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-guareiunidadesprisionais"
  },
  {
    "project_name": "Heliopolis",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-heliopolis"
  },
  {
    "project_name": "Cândido Fontoura",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-candidofontoura"
  },
  {
    "project_name": "Osasco - Centro",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-osasco-upacentro"
  },
  {
    "project_name": "Osasco - Conceição",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-osasco-upaconceicao"
  },
  {
    "project_name": "Osasco - Menck",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-osasco-upamenck"
  },
  {
    "project_name": "Bragança Paulista",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-bragancapaulista"
  },
  {
    "project_name": "Alambari",
    "description": "Prefeitura do Município de Alambari",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-alambari"
  },
  {
    "project_name": "Bom Sucesso do Itararé",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-bomsucessodoitarare"
  },
  {
    "project_name": "Tatuí",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-tatui"
  },
  {
    "project_name": "Birigui",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-birigui"
  },
  {
    "project_name": "Salto",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-salto"
  },
  {
    "project_name": "Guarulhos - HMCA",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-hmca-guarulhos"
  },
  {
    "project_name": "Sorocaba - Rede Sentinela Norte",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-sorocaba-sentinelanorte"
  },
  {
    "project_name": "Sorocaba - Rede Sentinela Centro",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-sorocaba-redesentinelacentro"
  },
  {
    "project_name": "Floresta",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-floresta"
  },
  {
    "project_name": "São José do Belmonte",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-saojosedobelmonte"
  },
  {
    "project_name": "Mirandopolis",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-mirandopolis"
  },
  {
    "project_name": "Osasco - UTI",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-osasco-drvivaldomartins"
  },
  {
    "project_name": "Mirandopolis - Dr Oswaldo Brandi",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-mirandopolis-droswaldobrandi"
  },
  {
    "project_name": "São Mateus",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-saomateus"
  },
  {
    "project_name": "Guarulhos - PA Maria Dirce",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-pa-mariadirce"
  },
  {
    "project_name": "Guarulhos - UPA Cumbica",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-upa-cumbica"
  },
  {
    "project_name": "Guarulhos - UPA São João Lavras",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-upa-saojoaolavras"
  },
  {
    "project_name": "Promissao - UTI",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-promissao"
  },
  {
    "project_name": "Ipero - UPA",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-upa-ipero"
  },
  {
    "project_name": "Osasco - Endoscopia",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-osasco-endoscopia"
  },
  {
    "project_name": "Mogi das Cruzes - USF",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-usf-mogidascruzes"
  },
  {
    "project_name": "Taipas - UTI",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-taipas-uti"
  },
  {
    "project_name": "Hortolândia",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-hortolandia"
  },
  {
    "project_name": "Guarulhos - CEMEG Pimentas",
    "description": "Desc",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-guarulhos-pimentas"
  },
  {
    "project_name": "Hospital Ipiranga",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-hospital-ipiranga"
  },
  {
    "project_name": "Taboão da Serra",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-taboaodaserra"
  },
  {
    "project_name": "Mogi das Cruzes - Mãe Mogiana",
    "description": "Descrição",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-mogidascruzes-maemogiana"
  },
  {
    "project_name": "Bebedouro",
    "description": "Bebedouro",
    "entity_name": "Beneficência Hospitalar de Cesário Lange",
    "entity_url": "bhcl",
    "project_url": "bhcl-bebedouro"
  }
]

export const projects2 = []


export const label = {
  displayMode: '1',
  primary_color: '#d72a',
  content_color: '#fff',
  bannerURL: 'https://res.cloudinary.com/dqiqkndcj/image/upload/v1715535760/qzdebsdpb2zzy9fnt2dc.jpg',
  header: {
    title: 'Plataforma de Transparência',
    subtitle: 'Beneficência Hospitalar de Cesário Lange',
    logoURL: 'https://res.cloudinary.com/dqiqkndcj/image/upload/v1715525086/wyacsqteodo86aeh5fxm.png',
  },
  banner: {
    title: 'Cesário Lange - Pronto Socorro',
    subtitle: 'Prefeitura do município de Alambari',
    description: 'Oferecendo atendimento de emergência ágil e eficiente para a comunidade de Cesário Lange.'
  }
}